var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFlamePriorityGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4.5C4.3064 3.33636 5.09597 0.377104 4.87197 0C7.89595 1.77778 8.336 4.52525 8 5.9798C7.664 7.43434 7.49201 8.5 8.5 8.5C9.50799 8.5 10.4159 6.78788 10.4159 5.9798C14.2799 10.3434 10.4159 16 5.87996 16C1.84799 16 0 13.7374 0 10.8283C0 7.91919 2.49201 5.95455 3.5 4.5Z",
    fill: "#BEBEBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlamePriorityGray);
export default __webpack_public_path__ + "static/media/icon-flame-priority-gray.657794a2d9ddfea0594ad9846549001f.svg";
export { ForwardRef as ReactComponent };